module.exports = __webpack_public_path__ + "static/img/result_list.9040aeda.png";